import { Chip } from '@nyce/admin-kit/ui';

// The page building blocks live in the kit (`@nyce/admin-kit/console`); re-exported here so pages keep one import.
export {
  useAsync,
  Page,
  Card,
  TableScroller,
  ActionsRow,
  EmptyState,
  useNotice,
  NoticeToast,
  ErrorBox,
  Loading,
  Kpi,
  ConfirmButton,
  TagsField,
  Tabs,
  listToText,
  textToList,
  ListField,
  useInterval,
  Pager,
  Code,
  useSort,
  SortTh,
  SortSelect,
  type Sort,
  type SortKeys,
  type Notice,
  type ListFieldProps,
} from '@nyce/admin-kit/console';

/** Marks a user created by a federated sign-in (Entra-only tenant); the tooltip carries the Entra object id. */
export function EntraChip({
  externalId,
  lastSignInAt,
}: {
  externalId?: string | null;
  lastSignInAt?: string | null;
}) {
  return (
    <span
      className="oph-scim"
      title={`Created at sign-in through Entra ID (object id ${externalId ?? '?'})${lastSignInAt ? `, last sign-in ${new Date(lastSignInAt).toLocaleString()}` : ''}`}
    >
      <Chip size="sm">Entra</Chip>
    </span>
  );
}

/** Marks a user or role provisioned over SCIM; the tooltip carries the identity provider's id. */
export function ScimChip({ externalId }: { externalId: string }) {
  return (
    <span className="oph-scim" title={`Provisioned over SCIM (external id ${externalId})`}>
      <Chip size="sm">SCIM</Chip>
    </span>
  );
}
